import axios, { AxiosError } from 'axios';

const instance = axios.create();

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

let retryCount = 0;

const retriableAccessTokenProvider = async () => {
    let accessToken = localStorage.getItem('accessToken');

    while (!accessToken) {
        accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
            if (retryCount === 3) break;
            retryCount += 1;
        }

        await delay(800);
    }

    return accessToken;
};

instance.interceptors.request.use(async request => {
    let token = await retriableAccessTokenProvider();
    request.headers['Authorization'] = `Bearer ${token}`;
    return request;
});

instance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('member');
            localStorage.removeItem('memberActivated');
            localStorage.removeItem('lastLogin');
            localStorage.removeItem('LS_ROUTE_KEY');
            if (window.location.pathname !== '/') {
                window.location.href = `${process.env.REACT_APP_VUE_CLIENT_URL}/login`;
            }
        }

        return Promise.reject(error);
    }
);

export default instance;
export type { AxiosError };
